/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AnnualClockCategory } from './AnnualClockCategory';
import {
    AnnualClockCategoryFromJSON,
    AnnualClockCategoryToJSON,
} from './AnnualClockCategory';

/**
 * Complete annual clock response
 * @export
 * @interface AnnualClock
 */
export interface AnnualClock {
    /**
     *
     * @type {string}
     * @memberof AnnualClock
     */
    title: string;
    /**
     *
     * @type {Array<AnnualClockCategory>}
     * @memberof AnnualClock
     */
    categories: AnnualClockCategory[];
}

/**
 * Check if a given object implements the AnnualClock interface.
 */
export function instanceOfAnnualClock(value: object): value is AnnualClock {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('categories' in value) || value['categories'] === undefined) return false;
    return true;
}

export function AnnualClockFromJSON(json: any): AnnualClock {
    return AnnualClockFromJSONTyped(json, false);
}

export function AnnualClockFromJSONTyped(json: any, _: boolean): AnnualClock {
    if (json == null) {
        return json;
    }
    return {

        'title': json['title'],
        'categories': ((json['categories'] as any[]).map(AnnualClockCategoryFromJSON)),
    };
}

export function AnnualClockToJSON(json: any): AnnualClock {
    return AnnualClockToJSONTyped(json, false);
}

export function AnnualClockToJSONTyped(value?: AnnualClock | null, _: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'title': value['title'],
        'categories': ((value['categories'] as any[]).map(AnnualClockCategoryToJSON)),
    };
}
